jQuery(function ($) {
  if (typeof wc_checkout_params === "undefined") return false;

  $(document.body).on("click", "#ajax-order-btn", function (evt) {
    evt.preventDefault();

    console.log(200);
    $.ajax({
      type: "POST",
      url: wc_checkout_params.ajax_url,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      enctype: "multipart/form-data",
      data: {
        action: "ajax_order",
        fields: $("form.checkout").serializeArray(), // Checkout form data
        user_id: ajax_order_params.user_id,
      },
      success: function (result) {
        console.log(result); // For debugging (to be removed)
        // You can handle order success here, e.g., redirecting to thank you page
      },
      error: function (error) {
        console.log(error); // For debugging (to be removed)
      },
    });
  });
});
